import moment from "moment";
import React, { useContext } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

import { searchInputOptions } from "../../../../unAssigned/studentFinanceApproval/epmrCancellation/constant";
import AMultiFieldSearchInput from "components/AMultiFieldSearchInput/AMultiFieldSearchInput";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import APopover from "../../../../common/a-popover";

import { EPMRContext } from "./context";
import EpmrFilterMenu from "./EpmrFilterMenu";
import { statusDropdown } from "./constants";

const Filters = ({
  crossInputHandler,
  searchInputValueHandler,
  businessAreaOptions,
  isLoading,
  updateReceiptsList,
}) => {
  const { setGlobalFilter, filterCount, globalFilter } =
    useContext(EPMRContext);

  const applyFilters = (newFilters, checked) => {
    const filters = {
      ...newFilters,
      ...(newFilters.receiptDateFrom && {
        receiptDateFrom: new Date(newFilters.receiptDateFrom).toISOString(),
      }),
      ...(newFilters.receiptDateTo && {
        receiptDateTo: new Date(
          moment(newFilters.receiptDateTo).endOf("day")
        ).toISOString(),
      }),
    };

    //  set globalFilters and call API
    setGlobalFilter((prev) => ({ ...prev, ...filters }));
    updateReceiptsList(filters, checked);
  };

  const selectOnlyPending = (checked) => {
    const newFilters = {
      ...globalFilter,
      status: checked
        ? statusDropdown.filter(
            (option) =>
              !["confirmed", "receipted"].includes(option.value.toLowerCase())
          )
        : [],
    };

    applyFilters(newFilters, checked);
  };

  return (
    <div className="d-flex">
      <FormControlLabel
        sx={{
          marginTop: "-25px",
          "& .MuiFormControlLabel-label": {
            fontSize: "12px",
            marginLeft: "-0.3rem",
          },
        }}
        control={
          <Checkbox
            onChange={(e) => selectOnlyPending(e.target.checked)}
            checked={
              globalFilter?.status.length === 3 &&
              !globalFilter?.status
                .map((option) => option.value)
                .includes("CONFIRMED")
            }
          />
        }
        label="Show only pending"
      />

      <SearchInput
        searchInputValueHandler={searchInputValueHandler}
        crossInputHandler={crossInputHandler}
        isLoading={isLoading}
      />

      <div className="d-flex justify-content-end">
        <APopover
          buttonComponent={(onClick, styles) => (
            <AButton
              className="tiny-semi-bold color-dark"
              disabled={isLoading}
              onClick={onClick}
              updatedStyle={{
                minWidth: "61px",
                ...(filterCount > 0
                  ? {
                      border: "1px solid #00B0F5",
                      color: "#00B0F5",
                    }
                  : styles),
              }}
            >
              Filters {filterCount > 0 && <>( {filterCount} )</>}
            </AButton>
          )}
          menuComponent={(closeForm) => (
            <>
              <EpmrFilterMenu
                businessAreaOptions={businessAreaOptions}
                closeForm={closeForm}
                applyFilters={applyFilters}
              />
            </>
          )}
          maxHeight={"calc(100vh - 180px)"}
        />
      </div>
    </div>
  );
};

export default Filters;

const SearchInput = ({
  searchInputValueHandler,
  crossInputHandler,
  isLoading,
}) => {
  const { globalFilter, setGlobalFilter } = useContext(EPMRContext);

  const searchInputHandler = (selectedField, inputValue) => {
    // call API when searched value is different from current global val
    if (inputValue !== globalFilter[selectedField]) {
      setGlobalFilter((prev) => ({ ...prev, [selectedField]: inputValue }));
      searchInputValueHandler({ [selectedField]: inputValue });
    }
  };

  return (
    <AMultiFieldSearchInput
      options={searchInputOptions}
      searchHandler={searchInputHandler}
      crossHandler={crossInputHandler}
      isLoading={isLoading}
    />
  );
};
